import React, { useState } from 'react';
import ItemHeadingWithDeleteButton from '../ItemHeadingWithDeleteButton';
import ItemActions from '../ItemActions';
import Form from '../Form';
import RequestUpdateModal from './RequestUpdateModal';
import { QUALIFICATION_TYPES } from '../../constants/qualificationTypes';

const Item = ({ item, index, onChange, dispatch, first, last }) => {
  const [isOpen, setOpen] = useState(false);
  const [isRequestUpdateOpen, setIsRequestUpdateOpen] = useState(false);
  const [errors, setErrors] = useState({
    type: false,
    name: false,
    credentialLink: false,
    issuedBy: false,
    issueDate: false,
    accreditationCountry: false,
    file: false,
  });
  const type = 'certifications';
  const identifier = `data.${type}.items[${index}].`;

  const isDisabled = true;

  const handleRequestUpdate = () => {
    setIsRequestUpdateOpen(true);
  };

  return (
    <>
      <RequestUpdateModal
        item={item}
        open={isRequestUpdateOpen}
        setOpen={setIsRequestUpdateOpen}
        type={QUALIFICATION_TYPES.CERTIFICATE}
      />
      <div className="my-4 border border-gray-200 rounded">
        <ItemHeadingWithDeleteButton
          setOpen={setOpen}
          isOpen={isOpen}
          item={item}
          dispatch={dispatch}
          type={type}
          disableDelete={isDisabled}
        />

        <div className={`${isOpen ? 'block' : 'hidden'} px-5 pb-5`}>
          <Form
            item={item}
            onChange={onChange}
            identifier={identifier}
            errors={errors}
            setErrors={setErrors}
            isDisabled={isDisabled}
          />

          <ItemActions
            handleRequestUpdate={handleRequestUpdate}
            dispatch={dispatch}
            first={first}
            identifier={identifier}
            item={item}
            last={last}
            onChange={onChange}
            type={type}
            isDisabled={false}
          />
        </div>
      </div>
    </>
  );
};

export default Item;
